import { useQuery } from '@tanstack/react-query'
import { Link } from 'react-router-dom'
import { api } from '../../../lib/api'
import { Card } from '../../ui/Card'
import { zi } from './comun'

/**
 * Task-urile generale legate de activitate.
 *
 * Fila se numește „De făcut", nu „Acțiuni": în codul v2 „acțiune" înseamnă task, iar în meniul
 * Marketing înseamnă sesiune de teren cu QR. Două lucruri diferite, același cuvânt — iar ecranul
 * e locul unde confuzia ar costa.
 */

interface Task {
  id: number
  title: string
  status: string
  priority: string | null
  urgent: boolean
  dueDate: string | null
  /** Oamenii de pe task, ca text („Adi și Ioana"). */
  responsabil: string | null
}

export function FilaDeFacut({ campanieId }: { campanieId: number }) {
  const q = useQuery<{ actiuni: Task[] }>({
    queryKey: ['campanie', campanieId, 'taskuri'],
    queryFn: async () => (await api.get(`/campanii/${campanieId}/actiuni`)).data,
  })
  const taskuri = q.data?.actiuni ?? []
  const acum = new Date()

  return (
    <Card title="De făcut">
      {taskuri.length === 0 ? (
        <p className="text-sm text-b4l-text-muted">
          Niciun task legat de activitate. Se leagă din modulul de task-uri.
        </p>
      ) : (
        <ul className="divide-y divide-b4l-border text-sm">
          {taskuri.map((t) => {
            const intarziat = t.dueDate != null && new Date(t.dueDate) < acum
            return (
              <li key={t.id} className="flex items-center gap-3 py-2">
                <Link to={`/task-uri?view=${t.id}`} className="text-b4l-blue-dark hover:underline">
                  #{t.id}
                </Link>
                <span className="flex-1">{t.title}</span>
                {t.urgent && (
                  <span className="rounded-full bg-b4l-red-light px-2 py-0.5 text-xs text-b4l-red-dark">
                    urgent
                  </span>
                )}
                <span className="text-xs text-b4l-text-muted">{t.responsabil ?? '—'}</span>
                <span
                  className={`w-24 text-right text-xs ${intarziat ? 'text-b4l-red-dark' : 'text-b4l-text-muted'}`}
                >
                  {zi(t.dueDate)}
                </span>
                <span className="w-24 text-right text-xs text-b4l-text-muted">{t.status}</span>
              </li>
            )
          })}
        </ul>
      )}
    </Card>
  )
}
